import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';

export const MainField = styled.div({
	display: 'flex',
	width: '100%',
	height: 'calc(100vh - 64px)',

	'@media (max-width: 1218px)': {
		flexDirection: 'column',
		marginBottom: '0px',
	},
});

export const ContentField = styled.div(props => ({
	width: '100%',
	background: '#ffffff',
	padding: ' 16px',
	overflowX: 'hidden',
	paddingBottom: '40px',

	'@media (min-width: 1218px)': {
		padding: '32px 40px',
		paddingBottom: '80px',
	},
}));
const slideIn = keyframes`
  from {
    max-height: 0;
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    max-height: 300px;
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideOut = keyframes`
  from {
    max-height: 300px;
    opacity: 1;
    transform: translateY(0);
  }
  to {
    max-height: 0;
    opacity: 0;
    transform: translateY(20px);
  }
`;
export const ScoreButton = styled.div(
	() => css`
		position: absolute;
		inset-inline-end: 5%;
		background: linear-gradient(96.21deg, #0046ae 0.29%, #000000 100%);
		box-shadow: 0px 4px 32px 0px #00000014;
		border-radius: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 2px;
		width: 32px;
		height: 32px;

		&.close {
			top: -35px;
			right: 0;
			img {
				color: #fff;
				width: 18px;
				height: 18px;
				background-color: inherit;
				padding: 0;
			}
		}
		&.open {
			img {
				color: #fff;
				width: 10px;
				height: 10px;
				background-color: inherit;
				padding: 0;
			}
			top: -35px;
			right: 0px;
		}
	`,
);
export const TotalScore = styled.span(
	() => css`
		// border-top: 3px solid #eb5f5f;
		// width: 100%;
		// margin-top: -19%;
		position: relative;
		display: inline-block;
		font-weight: 800;
		font-size: 48px;
		line-height: 61px;
		letter-spacing: 0.38px;
		text-transform: uppercase;
		color: #fff;

		&.cross::after {
			content: '';
			position: absolute;
			left: 0;
			top: 50%;
			background-color: red;
			width: 100%; /* Matches the width of the text */
			height: 3px; /* Thickness of the line */
			background-color: #eb5f5f; /* Line color */
			transform: translateY(-50%);
		}
	`,
);

export const Score = styled.div(
	({ theme }) => css`
		position: fixed;
		inset-inline-end: 5%;
		bottom: 5%;
		background: linear-gradient(96.21deg, #0046ae 0.29%, #000000 100%);
		box-shadow: 0px 4px 32px 0px #00000014;
		border-radius: 8px;

		.cup {
			width: 171px;
			position: absolute;
			bottom: 55%;
			z-index: -1;
			&.join {
				bottom: 69%;
			}
		}

		.menu_line {
			position: fixed;
			bottom: 20%;
			inset-inline-end: 5%;
			display: flex;
			flex-direction: column;
			gap: 8px;
			align-items: center;
			justify-content: center;
			width: 200px;
			overflow: hidden;

			&.open {
				animation: ${slideIn} 0.5s ease-out forwards;
			}

			&:not(.open) {
				animation: ${slideOut} 0.5s ease-out forwards;
			}

			.score_line {
				background: linear-gradient(96.21deg, #0046ae 0.29%, #000000 100%);
				border-radius: 200px;
				box-shadow: 0px 4px 32px 0px #00000014;
				padding: 8px;
				display: grid;
				grid-template-columns: 32px auto;
				gap: 8px;
				color: #fff;
				width: 100%;
				align-items: center;

				.img {
					width: 32px;
					height: 32px;
				}

				.text {
					font-family: HarmonyOS Sans;
					font-weight: 400;
					font-size: 14px;
					line-height: 24px;

					span {
						font-weight: 900;
						color: #00f6ad;
					}
				}
			}
		}

		.outer {
			display: grid;
			grid-template-columns: 1fr 1fr;
			grid-tempate-rows: auto auto;
			align-items: center;
			gap: 8px 29px;
			border-radius: 8px;
			background: linear-gradient(96.21deg, #0046ae 0.29%, #000000 100%);
			padding: 29px;
			.fix_height {
				height: 100%;
			}
			.inner {
				display: grid;
				grid-template-columns: 1fr;
				/* grid-template-rows: 40px 40px; */
			}
			.join_text {
				grid-column: 1/3;
				grid-row: 2;
				border-top: 1px solid #1c5890;
				padding-top: 5px;
				a {
					color: #86c5ff;
					text-decoration: underline;
					font-weight: 900;
				}
				.text {
					color: #eb5f5f;
					font-weight: 500;
					font-size: 14px;
					line-height: 20px;
					word-spacing: 2px;
					width: 360px;
				}
			}
			.scores {
				font-weight: 600;
				font-size: 20px;
				line-height: 25px;
				letter-spacing: 0.38px;
				text-transform: uppercase;
				color: #9d9d9d;
				display: flex;
				align-items: center;
			}

			button {
				align-self: center;
				background: #0286ff;
				color: #fff;
				border: 1px solid #000000;
				font-family: HarmonyOS Sans;
				font-weight: 700;
				font-size: 16px;
				line-height: 24px;
			}

			a {
				color: #86c5ff;
				text-decoration: underline;
				text-align: center;
				align-self: center;
			}
		}

		&.small_card {
			.outer {
				grid-template-columns: 1fr 3fr;
				padding: 9px;
				color: #fff;
				gap: 4px;
			}
			span {
				font-size: 20px;
				line-height: 100%;
			}
			img {
				padding: 4px;
				background-color: #14499a;
				border-radius: 2px;
			}
		}
	`,
);

export const SidebarContainer = styled.aside(
	({ theme }) => css`
		.aside_title_container {
			display: none;
		}
		.aside_title_mobile_container {
			display: flex;
			padding: 16px;
			padding-bottom: 12px;
			padding-top: 20px;

			h3 {
				color: ${theme.mode === 'dark' ? '#666666' : '#BEBEC0'};
				margin-bottom: -12px;
				font-size: 14px;
				font-weight: 400;
				line-height: 17px;
				text-align: left;
				letter-spacing: 0.02em;
			}
		}
		.vertical_view {
			display: none;
		}

		.sidebar_body {
			flex: 1;
		}

		.sidebar_bottom {
			display: flex;
			flex-direction: column;
			align-items: stretch;
			margin-bottom: 40px;
		}

		.sub_link_container {
			user-select: none;
			.sub_link_header {
				padding: 12px 20px;
				display: grid;
				align-items: center;
				grid-template-columns: 24px 1fr auto;
				gap: 12px;
				color: ${theme.colors.text.secondary};
				line-height: 19px;
				cursor: pointer;

				font-size: 16px;
				font-weight: 300;
				line-height: 19px;

				svg {
					width: 24px;
					height: 24px;
					color: ${theme.mode === 'light' ? '#464649' : '#939393'};
				}

				.drop_icon {
					transform: rotate(90deg);
					width: 20px;
					height: 20px;

					&.active {
						transform: rotate(-90deg);
					}
				}

				&:hover {
					background: ${theme.mode === 'light' ? '#E1E3E5' : '#2C2C2E'};
					&.active {
						background: ${theme.mode === 'dark' ? '#3A3A3C' : '#000000'};
						color: #ffffff;

						svg {
							color: ${theme.mode === 'light' ? '#FFFFFF' : '#FFFFFF'};
						}
					}
				}
			}

			.sub_links {
				display: flex;
				flex-direction: column;
				.sub_item {
					color: ${theme.colors.text.secondary};
					padding: 15px 20px 14px 56px;
					font-weight: 300;
					font-size: 16px;
					line-height: 19px;

					&.active {
						background: ${theme.mode === 'dark' ? '#3A3A3C' : '#000000'};
						color: #ffffff;

						svg {
							color: ${theme.mode === 'light' ? '#FFFFFF' : '#FFFFFF'};
						}
					}

					&:hover {
						background: ${theme.mode === 'light' ? '#E1E3E5' : '#2C2C2E'};
						&.active {
							background: ${theme.mode === 'dark' ? '#3A3A3C' : '#000000'};
							color: #ffffff;

							svg {
								color: ${theme.mode === 'light' ? '#FFFFFF' : '#FFFFFF'};
							}
						}
					}
				}
			}
		}

		@media (min-width: 1218px) {
			background: ${theme.mode === 'light' ? theme.colors.background.secondary : '#272729'};
			height: 100%;

			.aside_title_mobile_container {
				display: none;
				padding: 20px;
				h3 {
					margin: 0;
				}
			}

			.aside_title_container {
				display: flex;
				padding: 20px;

				h3 {
					color: ${theme.mode === 'dark' ? '#666666' : '#BEBEC0'};
					margin-bottom: -12px;
					font-size: 14px;
					font-weight: 400;
					line-height: 17px;
					text-align: left;
					letter-spacing: 0.02em;
					margin: 0;
				}
			}
			.vertical_view {
				width: 240px;
				display: flex;
				height: 100%;
				flex-direction: column;
				position: sticky;
				top: 64px;
				overflow: auto;
				height: calc(100vh - 64px);

				button {
					background-color: transparent;
					border: none;
					outline: none;
				}
				.vertical_item {
					padding: 12px 20px;
					display: flex;
					align-items: center;
					gap: 12px;
					color: ${theme.colors.text.secondary};
					line-height: 19px;
					cursor: pointer;

					font-size: 16px;
					font-weight: 300;
					line-height: 19px;

					svg {
						width: 24px;
						height: 24px;
						color: ${theme.mode === 'light' ? '#464649' : '#939393'};
					}

					&.active {
						background: ${theme.mode === 'dark' ? '#3A3A3C' : '#000000'};
						color: #ffffff;

						svg {
							color: ${theme.mode === 'light' ? '#FFFFFF' : '#FFFFFF'};
						}
					}

					&:hover {
						background: ${theme.mode === 'light' ? '#E1E3E5' : '#2C2C2E'};
						&.active {
							background: ${theme.mode === 'dark' ? '#3A3A3C' : '#000000'};
							color: #ffffff;

							svg {
								color: ${theme.mode === 'light' ? '#FFFFFF' : '#FFFFFF'};
							}
						}
					}
				}
			}
		}
	`,
);
